<button (click)="toggleIsActive()" mat-flat-button color="primary">
    <mat-icon
        [class.dark-icon]="!isDarkTheme()"
        [class.rotate90]="rotateIcon"
        class="padding-right">
            {{ icon }}
    </mat-icon>
    <span>{{ buttonText }}</span>
</button>
